import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { DateValidDumpModel } from './dto/date-valid-dump.model';
import { ExcelDumpModel } from './dto/excel-dump.model';
import { DrrExcel } from './entities/drrexcel.entity';
import { LedgerExcel } from './entities/ledgerexcel.entity';

@Injectable()
export class ExcelUploadService {

    constructor(
        @InjectRepository(LedgerExcel) private ledgerExcelRepository: Repository<LedgerExcel>,
        @InjectRepository(DrrExcel) private drrExcelRepository: Repository<DrrExcel>,
    ) { }

    async dateValidDump(dateValidate: DateValidDumpModel): Promise<boolean> {
        if (dateValidate.fileCategory === "LEDGER EXCEL") {
            const res = await this.ledgerExcelRepository.findOne({
                where: {
                    divisionId: dateValidate.divisionId,
                    clientCode: dateValidate.clientCode,
                    date: dateValidate.date,
                    fileCategory: dateValidate.fileCategory
                }
            });
            if (res) {
                return true;
            }
            return false;


        }
        else if (dateValidate.fileCategory === "DRR EXCEL") {
            const res = await this.drrExcelRepository.findOne({
                where: {
                    divisionId: dateValidate.divisionId,
                    clientCode: dateValidate.clientCode,
                    date: dateValidate.date,
                    fileCategory: dateValidate.fileCategory
                }
            });
            if (res) {
                return true;
            }
            return false;
        }


    }
    async excelDump(payload: ExcelDumpModel): Promise<boolean> {
        if (payload.fileCategory === "LEDGER EXCEL") {
            await this.ledgerDump(payload.dataValues, payload.divisionId, payload.clientCode, payload.fileCategory, payload.date, payload.createdUser).then((res) => {
                return true;
            }).catch((err) => {
                return false;
            })
        }
        else if (payload.fileCategory === "DRR EXCEL") {
            await this.drrDump(payload.dataValues, payload.divisionId, payload.clientCode, payload.fileCategory, payload.date, payload.createdUser, payload.divisionCode).then((res) => {
                return true;
            }).catch((err) => {
                return false;
            })
        }
        return true;

    }

    async ledgerDump(ledgerData: string[][], divisionId: number, clientCode: string, fileCategory: string, date: string, createdUser: string) {
        const ledgerEntities = [];
        try {
            const ledgerColumns = ["accountType", "accountCode", "description", "transactionDate", "baseAmount", "journalNo", "journalType"];
            await this.ledgerExcelRepository.delete({
                date: date,
                divisionId: divisionId
            });
            ledgerData.forEach((data, index) => {
                if (index !== 0) {
                    const ledgerEntity = new LedgerExcel();

                    data.forEach((eachField, index) => {
                        // console.log(eachField);
                        ledgerEntity[ledgerColumns[index]] = eachField;
                        ledgerEntity.divisionId = divisionId;
                        ledgerEntity.clientCode = clientCode;
                        ledgerEntity.fileCategory = fileCategory;
                        ledgerEntity.date = date;
                        ledgerEntity.createdUser = createdUser;
                    });
                    ledgerEntities.push(ledgerEntity)
                }
            });
            for (const ledgerEntity of ledgerEntities) {
                const saved = await this.ledgerExcelRepository.save(ledgerEntity);
                console.log(saved);
            }
        } catch (err) {
            console.log(err)
            return err;
        }
    }

    async drrDump(drrData: string[][], divisionId: number, clientCode: string, fileCategory: string, date: string, createdUser: string, divisionCode: string) {
        const drrEntities = [];
        const drrColumns = ["categoryId", "subCategoryId", "tdyActualRevenue", "tdyBudget", "tdyLastYearRevenue", "tdyVob", "tdyVoly", "mtdActualRevenue", "mtdBudget", "mtdLastYear", "mtdVob", "mtdVoly", "ytdActualRevenue", "ytdBudget", "ytdLastYearRevenue", "ytdVob", "ytdVoly"];

        await this.drrExcelRepository.delete({
            date: date,
            divisionId: divisionId,
            fileCategory: fileCategory,
            clientCode: clientCode,
            divisionCode: divisionCode

        });
        drrData.forEach((data, index) => {
            if (index !== 0) {
                const drrEntity = new DrrExcel();
                data.forEach((eachField, index) => {
                    console.log('---', eachField);
                    drrEntity[drrColumns[index]] = eachField;
                    drrEntity.divisionId = divisionId;
                    drrEntity.clientCode = clientCode;
                    drrEntity.fileCategory = fileCategory;
                    drrEntity.date = date;
                    drrEntity.createdUser = createdUser;
                    // drrEntity.clientCode = "VARUN";
                    drrEntity.divisionCode = divisionCode;
                });
                // console.log(drrEntity);
                drrEntities.push(drrEntity);
            }
        });
        return await this.drrExcelRepository.save(drrEntities)
        // return await this.excelDump()
    }


    async getDRRDetailsForDate(date: Date, divisionId: number, clientCode: string, categoryId: number, subCategoryId: number): Promise<{
        todayActual: string;
        todayBudget: string;
        todayLastYear: string;
        todayVob: string;
        todayVoly: string;
        mtdActual: string;
        mtdBudget: string;
        mtdLastYear: string;
        mtdVob: string;
        mtdVoly: string;
        ytdActual: string;
        ytdBudget: string;
        ytdLastYear: string;
        ytdVob: string;
        ytdVoly: string;
    }> {
        // console.log('----------------------ss', date, divisionId, clientCode, categoryId, subCategoryId);
        return await this.drrExcelRepository.createQueryBuilder('rr').select('rr.tdy_actual_revenue AS todayActual,rr.tdy_budget AS todayBudget,rr.tdy_last_year_revenue AS todayLastYear,rr.tdy_vob AS todayVob,rr.tdy_voly AS todayVoly,rr.mtd_actual AS mtdActual,rr.mtd_budget AS mtdBudget,rr.mtd_last_year AS mtdLastYear,rr.mtd_vob AS mtdVob,rr.mtd_voly AS mtdVoly,rr.ytd_actual AS ytdActual,rr.ytd_budget AS ytdBudget,rr.ytd_last_year AS ytdLastYear ,rr.ytd_vob AS ytdVob,rr.ytd_voly AS ytdVoly, rr.date AS date,rr.division_id AS divisionId, rr.client_code AS clientCode').where(`DATE(DATE) = '${date}' AND division_id = '${divisionId}' AND client_code = '${clientCode}' AND category_id = '${categoryId}' AND sub_category_id = '${subCategoryId}' `).getRawOne();

    }

    // async getDRRDetailsForMonth(month: number, year : number, divisionId: number, clientCode: string, categoryId: number, subCategoryId: number):Promise<{
    //     mtdActual: string;
    //     mtdBudget: string;
    //     mtdLastYear: string;
    //     mtdVob: string;
    //     mtdVoly: string;
    // }>  {
    //     return this.drrExcelRepository.createQueryBuilder('rr').select('SUM(rr.actual_revenue) AS mtdRevenue , SUM(rr.budget) AS mtdBudget , SUM(rr.last_year_revenue) AS mtdLastYearRevenue , (SUM(rr.actual_revenue) - SUM(rr.budget)) AS mtdVob , (SUM(rr.actual_revenue) - SUM(last_year_revenue))AS mtdVoly , DATE, division_id, client_code AS clientCode').where(`MONTH(DATE) = ${month} AND YEAR(DATE) = ${year} AND division_id = ${divisionId} AND client_code = '${clientCode}' AND category_id = ${categoryId} AND sub_category_id = ${subCategoryId}`).getRawOne();
    // }

    // async getDRRDetailsForYear(year : number,  divisionId: number, clientCode: string, categoryId: number, subCategoryId: number):Promise<{
    //     ytdActual: string;
    //     ytdBudget: string;
    //     ytdLastYear: string;
    //     ytdVob: string;
    //     ytdVoly: string;
    // }> {
    //     return this.drrExcelRepository.createQueryBuilder('rr').select('SUM(rr.actual_revenue) AS ytdRevenue , SUM(rr.budget) AS ytdBudget , SUM(rr.last_year_revenue) AS ytdLastYearRevenue , (SUM(rr.actual_revenue) - SUM(rr.budget)) AS ytdVob , (SUM(rr.actual_revenue) - SUM(last_year_revenue))AS ytdVoly , DATE, division_id, client_code AS clientCode').where(`YEAR(DATE) = ${year} AND division_id = ${divisionId} AND client_code = '${clientCode}' AND category_id = ${categoryId} AND sub_category_id = ${subCategoryId}`).getRawOne();
    // }

}
